module.exports = __webpack_public_path__ + "static/20-38f1fd45c8f836407e929cb1c0efe218.jpg";